<template>
  <v-text-field
    :rules="[validateHasValue]"
    :value="value"
    @input="value => $emit('input', value)"
    clearable
    outlined
    required
  ></v-text-field>
</template>

<script>
import { validateHasValue } from "@/lib/componentUtil";

export default {
  methods: {
    validateHasValue,
  },
  props: {
    value: {},
  },
};
</script>
